<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-5" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Ihr zuletzt gemessener HbA1c</span>
            <p class="new-text-lg text-centered">(Langzeitblutzuckerwert)</p>
        </header>

        <div class="form-input-wrapper">
            <span class="form-input-title new-text-xl text-bold">Datum der Messung</span>

            <div class="input-wrapper form-input-date-wrapper">
                <div class="form-input-date-inner-wrapper">
                    <form-input-type-select
                        name="last_measurement_day"
                        :options="getDays"
                        :value="getMeasurementDay"
                        full-border
                        label="Tag"
                        required
                    />

                    <form-input-type-select
                        name="last_measurement_month"
                        :options="getMonths"
                        :value="getMeasurementMonth"
                        full-border
                        label="Monat"
                        required
                    />

                    <form-input-type-select
                        name="last_measurement_year"
                        :options="getYears"
                        :value="getMeasurementYear"
                        full-border
                        label="Jahr"
                        required
                    />
                </div>

                <form-input-error v-if="errors.date" :error="errors.date"></form-input-error>
            </div>

            <span class="form-input-title new-text-xl text-bold">Einheit</span>

            <form-input-type-radio
                :options="[
                    { value: 'percentage', label: 'in %' },
                    { value: 'mmol', label: 'in mmol/mol' },
                ]"
                :value="hba1cUnit"
                :errors="errors.last_measurement_unit"
                name="last_measurement_unit"
                type="check"
                required
            />

            <span class="form-input-title new-text-xl text-bold">HbA1c Wert</span>

            <form-input-type-text
                label="HbA1c Wert"
                name="last_measurement_value"
                :value="hba1cValue"
                :errors="errors.last_measurement_value"
                full-border
                required
            />

            <v-button
                label="Weiter"
                size="lg"
                type="submit"
                @onClick="onClickButton()"
                full-width
            ></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                errors: {
                    date: null
                },
                isDisabled: true,
                hba1cDate: this.data && this.data.hba1c_date,
                hba1cUnit: this.data && this.data.hba1c_unit,
                hba1cValue: this.data && this.data.hba1c_value,
            }
        },

        mounted() {
            const that = this
            const selectDay = document.getElementById("last_measurement_day")
            const selectMonth = document.getElementById("last_measurement_month")
            const selectYear = document.getElementById("last_measurement_year")

            selectDay.addEventListener('change', function() {
                if($("#last_measurement_day").val() !== "" 
                    && $("#last_measurement_month").val() !== "" 
                    && $("#last_measurement_year").val() !== "") {
                    that.errors.date = null
                    that.$forceUpdate();
                }
            })

            selectMonth.addEventListener('change', function() {
                if($("#last_measurement_day").val() !== "" 
                    && $("#last_measurement_month").val() !== "" 
                    && $("#last_measurement_year").val() !== "") {
                    that.errors.date = null
                    that.$forceUpdate();
                }
            })

            selectYear.addEventListener('change', function() {
                if($("#last_measurement_day").val() !== "" 
                    && $("#last_measurement_month").val() !== "" 
                    && $("#last_measurement_year").val() !== "") {
                    that.errors.date = null
                    that.$forceUpdate();
                }
            })

            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50);
        },

        computed: {
            getDays() {
                var days = []

                for (let index = 1; index < 32; index++) {
                    days.push({label: index+".", value: index < 10 ? '0'+index : index})
                }

                return days
            },
            getMonths() {
                var months = [
                    {value: '01', label: 'Januar'},
                    {value: '02', label: 'Februar'},
                    {value: '03', label: 'März'},
                    {value: '04', label: 'April'},
                    {value: '05', label: 'Mai'},
                    {value: '06', label: 'Juni'},
                    {value: '07', label: 'Juli'},
                    {value: '08', label: 'August'},
                    {value: '09', label: 'September'},
                    {value: '10', label: 'Oktober'},
                    {value: '11', label: 'November'},
                    {value: '12', label: 'Dezember'}
                ]

                return months
            },
            getYears() {
                var years = []

                for (let index = moment().year(); index > 2000; index--) {
                    years.push({label: index.toString(),})
                }

                return years
            },
            getMeasurementDay() {
                if(this.hba1cDate) {
                    return this.hba1cDate.split("-")[2]
                }

                return null
            },
            getMeasurementMonth() {
                if(this.hba1cDate) {
                    return this.hba1cDate.split("-")[1]
                }

                return null
            },
            getMeasurementYear() {
                if(this.hba1cDate) {
                    return this.hba1cDate.split("-")[0]
                }

                return null
            }
        },

        methods: {
            onClickButton() {
                this.validate()

                if(!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                }
            },
            validate() {
                var radioButtonGroup = document.getElementsByName("last_measurement_unit");
                    
                var checkedRadio = Array.from(radioButtonGroup).find(
                    (radio) => radio.checked
                );

                if($("#last_measurement_day").val() == "" 
                    || $("#last_measurement_month").val() == ""
                    || $("#last_measurement_year").val() == "") {
                    this.errors.date = "Datum muss angegeben werden."
                    this.isDisabled = true
                    this.$forceUpdate();
                }

                if(checkedRadio === undefined) {
                    this.errors.last_measurement_unit = ['Einheit muss angegeben werden.']
                    this.isDisabled = true
                    this.$forceUpdate();
                }

                if($("#last_measurement_value").val() == "") {
                    this.errors.last_measurement_value = ["HbA1c Wert muss angegeben werden."]
                    this.isDisabled = true
                    this.$forceUpdate();
                }

                if($("#last_measurement_day").val() !== "" && $("#last_measurement_month").val() !== "" && $("#last_measurement_year").val() !== "") {
                    this.hba1cDate = $("#last_measurement_year").val()+'-'+$("#last_measurement_month").val()+'-'+$("#last_measurement_day").val()

                    if(moment(this.hba1cDate).isValid()) {
                        this.isDisabled = false
                    } else {
                        this.isDisabled = true
                        this.errors.date = "Datum der Messung muss ein gültiges Datum sein."
                    }
                }

                if(moment(this.hba1cDate).isValid() 
                    && checkedRadio !== undefined
                    && $("#last_measurement_value").val() !== "") {
                    this.errors = {
                        last_measurement_unit: null,
                        date: null,
                        last_measurement_value: null
                    }

                    this.hba1cUnit = checkedRadio.value
                    this.hba1cValue = $("#last_measurement_value").val()

                    this.isDisabled = false
                    this.$forceUpdate();
                }
            },
            submit() {
                var data = {
                    uuid: this.uuid,
                    answers: {
                        question_1: {
                            key: 'hba1c_date',
                            value: this.hba1cDate
                        },
                        question_2: {
                            key: 'hba1c_unit',
                            value: this.hba1cUnit
                        },
                        question_3: {
                            key: 'hba1c_value',
                            value: this.hba1cValue
                        },
                        last_tab: {
                            key: 'last_tab',
                            value: this.type === 'first' ? '6' : '4'
                        }
                    }
                }

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
            saveData() {
                var radioButtonGroup = document.getElementsByName("last_measurement_unit");
                    
                var checkedRadio = Array.from(radioButtonGroup).find(
                    (radio) => radio.checked
                );

                this.hba1cDate = $("#last_measurement_year").val()+'-'+$("#last_measurement_month").val()+'-'+$("#last_measurement_day").val()
                this.hba1cUnit = checkedRadio ? checkedRadio.value : null
                this.hba1cValue = $("#last_measurement_value").val()

                var data = {
                    answers: {
                        question_1: {
                            key: 'hba1c_date',
                            value: this.hba1cDate
                        },
                        question_2: {
                            key: 'hba1c_unit',
                            value: this.hba1cUnit
                        },
                        question_3: {
                            key: 'hba1c_value',
                            value: this.hba1cValue
                        }
                    }
                }

                this.$emit('clicked', data.answers, false)
            }
        }
    }
</script>
